import { Component, OnInit } from '@angular/core';
import { EventsHubService } from '../../../../core/events-hub.service';
import { QuarterPickerDateComponent } from '../../quarter-picker/quarter-picker-date/quarter-picker-date.component';

@Component({
    selector: 'rms-year-portion-picker-values',
    templateUrl: './year-portion-picker-values.component.html',
    styleUrls: ['./year-portion-picker-values.component.scss'],
    standalone: false
})
export class YearPortionPickerValuesComponent extends QuarterPickerDateComponent implements OnInit {

  public quarterList = [
    {selected: false, name: '1Q'},
    {selected: false, name: '2Q'},
    {selected: false, name: '3Q'},
    {selected: false, name: '4Q'},
    {selected: false, name: '1H'},
    {selected: false, name: 'MY'},
    {selected: false, name: '2H'},
    {selected: false, name: 'YE'},
    {selected: false, name: 'Jan', value: 'January'},
    {selected: false, name: 'Feb', value: 'February'},
    {selected: false, name: 'Mar', value: 'March'},
    {selected: false, name: 'Apr', value: 'April'},
    {selected: false, name: 'May', value: 'May'},
    {selected: false, name: 'Jun', value: 'June'},
    {selected: false, name: 'Jul', value: 'July'},
    {selected: false, name: 'Aug', value: 'August'},
    {selected: false, name: 'Sep', value: 'September'},
    {selected: false, name: 'Oct', value: 'October'},
    {selected: false, name: 'Nov', value: 'November'},
    {selected: false, name: 'Dec', value: 'December'}
  ];

  constructor(eventsHubService: EventsHubService) {
    super(eventsHubService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
